import React, { useEffect, useState, useRef, Suspense } from 'react';
import SimpleReactValidator from 'simple-react-validator';
import { useNavigate } from 'react-router-dom';
import ZipCode from './ZipModal';
import PropTypes from 'prop-types';
import RenderIf from '../../Utility/RenderIf';
import { resetState } from '../../store/action';
import { useDispatch } from 'react-redux';
import { clearCart, getDiscount, validateStorageZipCode } from '../../data/API';
import { ReactSession } from 'react-client-session';
import { Helmet } from 'react-helmet';
import Offers from "../Offers";
import {
  getHomeData,
  getTestimonials,
  getContactInfo,
  getWhyUs,
  getLocations,
  checkZipCode,
  saveQuote
} from '../../data/API';

import toast from 'react-hot-toast';
import './index.css';

import SimpleSlider from './slider';
import { Col, Container, Row } from 'react-bootstrap';
import FilledBox from '../../assets/images/filled_box.png';
import Storage from '../../assets/images/storage.png';
import { Button, Form, Image, Input, message, Select } from 'antd';
import uuid from 'react-uuid';
import { setPincode } from '../StorageBox/store/actionCreators';
import { getToken } from '../../utils/token';
const LazyImage = React.lazy(() => import('../../Utility/LazyImage'));

export default function Home(props) {
  const { Option } = Select;

  const [mainloader, setMainloader] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [errorMsg, setMsg] = useState('');
  const [isError, setError] = useState(false);
  const navigate = useNavigate();
  const [, forceUpdate] = useState();
  const validator = useRef(new SimpleReactValidator());

  const [home, setHomeData] = useState();
  const [testimonials, setTestimonials] = useState([]);
  const [why_us, setWhyUs] = useState([]);
  const [contact_info, setContactInfo] = useState([]);
  const [locations, setLocation] = useState([]);
  const [zipcode, setZipcode] = useState([]);
  const [popupData, setPopupData] = useState(false);
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [form] = Form.useForm();
  const loginToken = getToken();

  const onFinish = (val) => {
    message.success('Submit success!');
  };
  const onFinishFailed = (err) => {
    message.error('Something Went Wrong Try Again!');
  };
  const dispatch = useDispatch();

  const [values, setValues] = useState({
    full_name: '',
    email: '',
    phone: '',
    address: '',
    delivery_date: '',
    pickup_zipcode: '',
    delivery_zipcode: ''
  });

  const handleChange = (event) => {
    setValues({ ...values, [event.target.name]: event.target.value });
    const item = {
      value: true,
      expiry: new Date().getTime()
    };
    // console.log(item.expiry);
    localStorage.setItem('zipcode', JSON.stringify(item));
  };
  const handleClosePopup = () => {
    setPopupVisible(false);
  };
  const loadiframe = () => {
    window.$('#myModal').modal('show');
    document.getElementById('iframediv').innerHTML =
      " <button type='button' className='close' onClick= window.$('#myModal').modal('hide') > <span aria-hidden='true'>&times;</span> </button>  <iframe src='https://www.google.com/maps/d/embed?mid=1tKoG-65lKUliYMUheHqFHds9xbLieQQ' width='640' height='480'></iframe>";
  };

  const handleQuoteSubmit = (e) => {
    e.preventDefault();
    if (validator.current.allValid()) {
      saveQuote(values)
        .then((res) => {
          toast.success('Successfully created!');
          ('Message sent successfully');
        })
        .catch((e) => {
          toast.error('Some error occure,please try again');
        });
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };

  const handleZipCode = async (values) => {
    if (values?.service_type && values?.service_type == 'STORAGE_ON_DEMAND') {
      if (validator.current.allValid()) {
        setSubmitLoader(true);

        let payload = {
          deliveryZipCode: values.delivery_zipcode
        };

        let validateRes = await validateStorageZipCode(payload);

        if (validateRes?.data?.data?.serviceExist) {
          dispatch(setPincode(values.delivery_zipcode));
          setSubmitLoader(false);

          if (loginToken) {
            navigate('/storage-box/buying-box');
          } else {
            // navigate('/storage-box/login');
            navigate('/login');
          }
        } else {
          setSubmitLoader(false);
          message.error('Service not available in this area.');
        }
      } else {
        validator.current.showMessages();
        forceUpdate(1);
        return false;
      }
    } else {
      setMainloader(true);
      if (validator.current.allValid()) {
        setSubmitLoader(true);

        let obj = {
          pickup_zipcode: values.pickup_zipcode,
          delivery_zipcode: values.delivery_zipcode
        };
        checkZipCode(obj)
          .then((res) => {
            if (res?.data?.success) {
              setSubmitLoader(false);
              navigate('/packages');
            } else {
              setSubmitLoader(false);
              message.error(res?.data?.message);
            }
          })
          .catch((e) => {
            setSubmitLoader(false);
            console.log(e);
          });
      } else {
        validator.current.showMessages();
        forceUpdate(1);
        return false;
      }
    }
  };

  useEffect(() => {
    clearCart(ReactSession.get('session'));
    dispatch(resetState());
    ReactSession.set('session', uuid());
    var cancel = false;
    props.setshowZipModal(true);

    getHomeData()
      .then((res) => {
        if (cancel) return;
        setHomeData(res.data);
      })
      .catch((e) => console.log(e));

    getWhyUs()
      .then((res) => {
        if (cancel) return;
        setWhyUs(res.data);
      })
      .catch((e) => console.log(e));

    getTestimonials('general')
      .then((res) => {
        if (cancel) return;
        setTestimonials(res.data);
      })
      .catch((e) => console.log(e));

    getLocations()
      .then((res) => {
        if (cancel) return;
        setLocation(res.data);
      })
      .catch((e) => console.log(e));

    if (zipcode === '') {
      setZipcode(false);
    }

    return () => {
      cancel = true;
    };
  }, []);

  const [showM, setModal] = useState(false);
  const [toggleModal, setToggleModal] = useState(false);
  const hideZModal = () => {
    setModal(false);
  };

  const showZModal = () => {
    setModal(true);
  };
  function toggleModalFunction(argu) {
    setToggleModal(argu);
  }


  const fetchOffer = async () => {
  try {
    let res = await getDiscount();
    if (res && res.data && res.data.length > 0) {
      setPopupData(res.data);
      if (res.data[0].display_location === "both" || res.data[0].display_location === "home_page") {
        setPopupVisible(true);
      }
    } else {
      console.error('No data available');
    }
  } catch (error) {
    console.error('Error fetching offer:', error);
  }
};


  // const fetchOffer = async () => {
  //   let res = await getDiscount();
  //   setPopupData(res?.data);
  //   if(res?.data[0].display_location == "both" || res?.data[0].display_location == "home_page"){
  //     setPopupVisible(true)
  //   }
  // }
  useEffect(() => {
    fetchOffer()
  }, [])

  useEffect(() => {
    const scrollContainer = document.getElementById('alternativeUsesScroll');
    const dots = document.querySelectorAll('.pagination-dot');

    if (!scrollContainer || dots.length === 0) return;

    const handleScroll = () => {
      const scrollLeft = scrollContainer.scrollLeft;
      const cardWidth = 357; // Card width
      const gap = 17; // Gap between cards
      const groupWidth = (cardWidth * 3) + (gap * 2); // Width of 3 cards + gaps

      // Determine which group is visible
      const currentIndex = Math.round(scrollLeft / groupWidth);

      // Update active dot
      dots.forEach((dot, index) => {
        if (index === currentIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    };

    // Add click handlers to dots
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        const cardWidth = 357;
        const gap = 17;
        const groupWidth = (cardWidth * 3) + (gap * 2);
        scrollContainer.scrollTo({
          left: groupWidth * index,
          behavior: 'smooth'
        });
      });
    });

    scrollContainer.addEventListener('scroll', handleScroll);

    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, [])

  return (
    <>
      <Helmet>
        <title>BlueBox: Moving Box Rentals & Storage in San Francisco Bay Area</title>
        <meta
          name="description"
          content="BlueBox provides a greener, cheaper and more convenient moving box rentals and storage on-demand services in the San Francisco Bay Area"
        />
        <meta
          name="keywords"
          content="reusable moving box rentals, storage San Francisco, moving box rentals San Francisco, moving box rentals San Jose, moving box rentals Oakland"
        />
      </Helmet>
      <ZipCode
        showModal={toggleModal}
        hideModal={hideZModal}
        zipcode={zipcode}
        setZipcode={setZipcode}
        toggleModal={toggleModal}
        toggleModalFunction={toggleModalFunction}
        storeStatus={props.storeStatus}
        storeStatusMessage={props.storeStatusMessage}
      />
      {/* <!-- hero --> */}
      <Offers isVisible={isPopupVisible}
        onClose={handleClosePopup}
        popupData={popupData} />
      <section className="hero position-relative">
        <div className="container">
          <div className="row">
            <div className="col-md-12 position-relative home-banner">
              <h1 className="mb-0 font-weight-bold banner-text aos-init aos-animate">
              Sustainable Moving and Storage Solutions for the San Francisco Bay Area
              </h1>

              <h4 className="text-white text-center mt-3">
              Rent moving boxes to reduce the stress and chaos of packing and moving and simplify
              your life with our convenient Storage On-Demand services.   
              </h4>
              <div className="btns mt-4">
                <div
                  className="row d-flex justify-content-center"
                  style={{ width: '100%', padding: 0, margin: 0 }}>
                  <div className="">
                    <button
                      className="btn btn-primary w-100 d-block aos-init aos-animate"
                      // data-toggle="modal"
                      // data-target="#zipModal"
                      onClick={() => {
                        showZModal();
                        setToggleModal(true);
                      }}>
                      Start Your Order
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-md-6">
              <img
                src="img/help.png"
                className="img-fluid position-absolute"
                data-aos="zoom-in"
                data-aos-duration="1500"
                alt="somethinghelping Men"
              />
            </div> */}
          </div>
        </div>
      </section>
      {/* <!-- hero --> */}
      {/* <!-- Modal --> */}
      <ZipCode showModal={showM} hideModal={hideZModal} />

      {/* <!-- We deliver  --> */}
      <Container fluid={true} className="choose-landing-page py-5">
        <Row className="align-items-center justify-content-center text-center">
          <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
            <p className="land-head clr-black">
              BlueBox provides a greener, cheaper and more convenient alternative to traditional
              moving and storage services.
            </p>
          </Col>

          <Col
            xxl={12}
            xl={12}
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="align-items-center d-flex justify-content-center pb-3">
            <div className="land-divider"></div>
          </Col>

          <Col xxl={7} xl={7} lg={7} md={8} sm={12} xs={12}>
            <p className="land-sub-head clr-black">
              Moving? Don’t buy moving boxes. Rent them! Calm the moving chaos by renting reusable
              moving boxes with free delivery and pick up. Need more storage? We pick up your
              items, store them, and bring them back to you anytime you need them.
            </p>
          </Col>
        </Row>

        <Row className="align-items-center justify-content-center pt-4">
          <Col xxl={6} xl={6} lg={6} md={10} sm={12} xs={12}>
            <Row className="align-items-center justify-content-center">
              <Col xxl={4} xl={4} lg={6} md={5} sm={12} xs={12} className="py-2">
                <div className="land-card">
                  <Image
                    src={FilledBox}
                    preview={false}
                    alt="filled_box"
                    className="land-card-image mb-4"
                    width="100"
                    height="100"
                  />

                  <Button
                    type="primary"
                    size="large"
                    className="land-card-btn"
                    onClick={() => navigate('/moving-boxes')}
                    block>
                    Rent Moving Boxes
                  </Button>
                </div>
              </Col>
              <Col xxl={4} xl={4} lg={6} md={5} sm={12} xs={12} className="py-2">
                <div className="land-card land-card-storage">
                  <Image
                    src={Storage}
                    preview={false}
                    alt="storage"
                    className="land-card-image mb-4"
                    width="100"
                    height="100"
                  />

                  <Button
                    type="primary"
                    size="large"
                    className="land-card-btn"
                    onClick={() => navigate('/storage-boxes')}
                    block>
                    Storage On-Demand
                  </Button>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      {/* About Us */}

      <div className="container about-section" style={{ background: 'white', paddingTop: '80px', paddingBottom: '80px' }}>
        <div className="row justify-content-center" style={{ alignItems: 'center' }}>
          <div className="col-md-6 d-flex justify-content-center about-image">
            <Suspense fallback={<div>Loading...</div>}>
              <LazyImage
                src="img/home-about-us.png"
                alt="About"
                className="about-img-lg"
              />
            </Suspense>
            <Suspense fallback={<div>Loading...</div>}>
              <LazyImage
                className="about-img-sm"
                src="img/home-about-us.png"
                alt="About"
              />
            </Suspense>
          </div>
          <div className="col-md-6 d-flex flex-column align-items-start fs-23 about-text">
            <p className="about-us-heading fw-600 ">
              About Us
            </p>
            <p>
              BlueBox exists to <span style={{ color: '#0080ff', fontWeight: '600' }}>make life easier and cut waste</span> - replacing flimsy, throwaway cardboard with durable, reusable crates that keep homes, job sites, and cities cleaner.
            </p>

            <p>
              Sustainability isn&apos;t a tagline for us. <span style={{ color: '#0080ff', fontWeight: '600' }}>It&apos;s the operating system.</span> Every rental helps reduce landfill volume and the demand for single-use packaging, and a portion of our efforts supports ocean-bound plastic reduction. As our communities grow, so does our responsibility - to keep plastics out of waterways, to design for reuse, and to deliver a faster, cleaner experience that&apos;s better for people, the planet, and our oceans... Better boxes. Better planet.
            </p>
            <Button className="about-us-btn about-us-btn-red" onClick={() => navigate('/about')} block>
              Learn more About Us
            </Button>
          </div>
        </div>
        
      </div>

      {/* About Us End*/}

      {/* Core Brand Promise */}
      <section className="core-brand-promise">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h2 className="core-brand-title text-center">Core Brand Promise</h2>
              <p className="core-brand-text text-center">
                At BlueBox, we believe moving shouldn&apos;t cost the Earth. BlueBox is more than just a smarter way to move — it&apos;s a mission-driven service that helps protect our planet. By replacing disposable cardboard with durable, reusable moving boxes, we cut down on waste, save trees, and keep plastics and debris out of our oceans.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Core Brand Promise End */}

      {/* <!-- why choos us --> */}

      <section className="whyChooseUs">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h4 className="d-center underline">
                Why Choose BlueBox?
              </h4>
            </div>
            <div className="whyChooseUs_banner">
              <div className="row">
                <div className="col-md-4">
                  <img src="img/homepageicons-01.png" alt="" width="100" height="100" className='mx-auto'/>
                  <h4>Free Delivery & Pick Up</h4>
                  <p className="sub-description">
                    We provide free delivery and pick up of our moving boxes throughout the San
                    Francisco Bay Area and beyond
                  </p>
                </div>
                <div className="col-md-4">
                  <img src="img/homepageicons-02.png" alt="" width="100" height="100" className='mx-auto' />
                  <h4>Timed Deliveries</h4>
                  <p className="sub-description">
                    We offer timed deliveries to ensure boxes arrive when you need them
                  </p>
                </div>
                <div className="col-md-4">
                  <img src="img/homepageicons-03.png" alt="" width="100" height="100" className='mx-auto' />
                  <h4>Next-Day Delivery</h4>
                  <p className="sub-description">
                    Need boxes in a hurry? We offer next-day delivery. Just order by 3 PM the day
                    before
                  </p>
                </div>
                <div className="col-md-4">
                  <img src="img/homepageicons-04.png" alt="" width="100" height="100" className='mx-auto' />
                  <h4>Moving Supplies</h4>
                  <p className="sub-description">
                    We sell moving supplies to help you get packing as soon as boxes arrive
                  </p>
                </div>
                <div className="col-md-4">
                  <img src="img/homepageicons-05.png" alt="" width="100" height="100" className='mx-auto' />
                  <h4>Earth Friendly</h4>
                  <p className="sub-description">
                    Using reusable boxes saves trees and keeps cardboard out of landfills. No dumps,
                    no dumpsters, no waste
                  </p>
                </div>
                <div className="col-md-4">
                  <img src="img/homepageicons-06.png" alt="" width="100" height="100" className='mx-auto' />
                  <h4>Stress Free</h4>
                  <p className="sub-description">
                    Moving can be stressful. Packing doesn’t have to be. Pack happy!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- why choos us --> */}

      {/* Join the Blue Move */}
      <section className="container">
        <div className=" join-blue-move">
          <div className="row align-items-center">
            <div className="col-md-9">
              <h3 className="join-blue-title">
                Join the <span className="blue-text">Blue</span> Move
              </h3>
              <p className="join-blue-text">
                Ready to ditch the cardboard chaos and do right by the coast? Rent BlueBoxes for your next move. Your back (and the bay) will thank you.
              </p>
            </div>
            <div className="col-md-3 text-right">
              <Button
                className="join-blue-btn"
                onClick={() => {
                  showZModal();
                  setToggleModal(true);
                }}
              >
                Order boxes
              </Button>
            </div>
          </div>
        </div>
      </section>
      {/* Join the Blue Move End */}

      {/* Alternative Uses Section */}
      <section className="alternative-uses-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h4 className="alternative-uses-title">
                Not moving? See BlueBox Alternative Uses!
              </h4>
            </div>
          </div>
          <div className="alternative-uses-scroll-container" id="alternativeUsesScroll">
            <div className="alternative-uses-cards">
              <div className="alternative-use-card">
                <div className="card-image-wrapper">
                  <Suspense fallback={<div>Loading...</div>}>
                    <LazyImage
                      src="img/home-renovations.png"
                      alt="Home Renovations"
                      className="card-image"
                    />
                  </Suspense>
                </div>
                <div className="card-title-banner">Home Renovations</div>
                <p className="card-description">
                  Temporary storage for kitchen items, clothing, or furniture during remodels or repairs.
                </p>
              </div>

              <div className="alternative-use-card">
                <div className="card-image-wrapper">
                  <Suspense fallback={<div>Loading...</div>}>
                    <LazyImage
                      src="img/seasonal-storage.png"
                      alt="Seasonal Storage Swaps"
                      className="card-image"
                    />
                  </Suspense>
                </div>
                <div className="card-title-banner">Seasonal Storage Swaps</div>
                <p className="card-description">
                  Efficient packing of winter/summer clothes, decorations, patio cushions, etc.
                </p>
              </div>

              <div className="alternative-use-card">
                <div className="card-image-wrapper">
                  <Suspense fallback={<div>Loading...</div>}>
                    <LazyImage
                      src="img/decluttering.png"
                      alt="Decluttering & Minimalism Projects"
                      className="card-image"
                    />
                  </Suspense>
                </div>
                <div className="card-title-banner">Decluttering & Minimalism Projects</div>
                <p className="card-description">
                  For anyone reducing clutter, creating a more functional home, or staging items for donation, resale, or estate plans.
                </p>
              </div>

              <div className="alternative-use-card">
                <div className="card-image-wrapper">
                  <Suspense fallback={<div>Loading...</div>}>
                    <LazyImage
                      src="img/garage-attic.png"
                      alt="Garage & Attic Clean-Outs"
                      className="card-image"
                    />
                  </Suspense>
                </div>
                <div className="card-title-banner">Garage & Attic Clean-Outs</div>
                <p className="card-description">
                  Sturdy and uniform bins ideal for sorting, donating or storing.
                </p>
              </div>

              <div className="alternative-use-card">
                <div className="card-image-wrapper">
                  <Suspense fallback={<div>Loading...</div>}>
                    <LazyImage
                      src="img/college-dorm.png"
                      alt="College Student Moves"
                      className="card-image"
                    />
                  </Suspense>
                </div>
                <div className="card-title-banner">College Dorm Moves</div>
                <p className="card-description">
                  Perfect for student move-ins and move-outs, or for storing belongings between semesters and over summer break.
                </p>
              </div>

              <div className="alternative-use-card">
                <div className="card-image-wrapper">
                  <Suspense fallback={<div>Loading...</div>}>
                    <LazyImage
                      src="img/business-office.png"
                      alt="Business & Office Moves"
                      className="card-image"
                    />
                  </Suspense>
                </div>
                <div className="card-title-banner">Business & Office Moves</div>
                <p className="card-description">
                  Reliable boxes for office relocations, equipment storage, or document archiving.
                </p>
              </div>
            </div>
          </div>
          <div className="alternative-uses-pagination">
            <span className="pagination-dot active" data-index="0"></span>
            <span className="pagination-dot" data-index="1"></span>
          </div>
        </div>
      </section>
      {/* Alternative Uses Section End */}

      {/* We Value Our Community and Environment Section */}
      <section className="community-environment-section" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/img/ocean.png)` }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h2 className="community-environment-title">We Value Our Community and Environment</h2>
              <p className="community-environment-text">
                With every BlueBox order, you&apos;re helping to reduce the tons of cardboard headed to landfills, thousands of gallons of oil and water used to create cardboard, and let&apos;s not forget our beautiful trees.
              </p>
              <h3 className="cardboard-requirement-title">Producing one ton of cardboard requires...</h3>
              <div className="cardboard-stats">
                <div className="stat-item">
                  <p className="stat-number">17</p>
                  <p className="stat-label">Trees</p>
                </div>
                <div className="stat-item">
                  <p className="stat-number">79</p>
                  <p className="stat-label">Gallons of Oil</p>
                </div>    
                <div className="stat-item">
                  <p className="stat-number">7000</p>
                  <p className="stat-label">Gallons of Water</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* We Value Our Community and Environment Section End */}

      {/* Why the Ocean Section */}
      <section className="ocean-north-star-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="ocean-title">Why the Ocean Is Our North Star</h2>
              <p className="ocean-description">
                Plastic and packaging waste doesn&apos;t just disappear—it leaks into waterways and, ultimately, our oceans. Globally, an estimated 11 million metric tons of plastic enter the ocean each year. Choosing reusables keeps materials in circulation and reduces the volume of single-use stuff headed for landfills, storm drains, and shorelines.
              </p>
              <p className="ocean-highlight">
                <strong>Your move matters.</strong> Every time you choose BlueBox, you&apos;re choosing to keep waste out of landfills and plastic out of our oceans — while making your move easier, faster, and more affordable.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Why the Ocean Section End */}

      {/* Ocean First Commitments Section */}
      <section className="ocean-commitments-section">
        <div className="ocean-wave-bg"></div>
        <div className="ocean-wave-top">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h2 className="commitments-title">Our Ocean-First Commitments</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="commitment-card">
                <h3 className="commitment-card-title">Reduce single-use waste</h3>
                <p className="commitment-card-text">
                  Every rental keeps disposable packaging out of the system.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="commitment-card">
                <h3 className="commitment-card-title">Continuous improvement</h3>
                <p className="commitment-card-text">
                  We&apos;re always refining routes, materials, and processes to cut emissions and increase reuse cycles.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="commitment-card">
                <h3 className="commitment-card-title">Community impact</h3>
                <p className="commitment-card-text">
                  We champion local clean-up efforts and educational initiatives that protect Bay Area waterways.
                </p>
              </div>
            </div>
          </div>
        </div></div>
      </section>
      {/* Ocean First Commitments Section End */}

      <div className="container-fluid " style={{ background: 'white', paddingTop: '50px', paddingBottom: '50px'}}>
        <div className="row section-ml mt-4">
          <div className="col-md-6 col-sm-12 d-flex justify-content-end about-image">
            <Suspense fallback={<div>Loading...</div>}>
              <LazyImage
                className=""
                src="img/App-section.png"
                alt="App"
                width="505"
                height="545"
              />
            </Suspense>
            <Suspense fallback={<div>Loading...</div>}>
              <LazyImage
                className="app-section-img-sm"
                src="img/App-section-sm.png"
                alt="App"
                width="335"
                height="360"
              />
            </Suspense>
          </div>
          <div className="col-md-6 col-sm-12 d-flex flex-column justify-content-center fs-23 about-text download-app">
            <p className="about-us-heading-download fw-600 d-center">
              Download our app
              <div className="land-divider"></div>
            </p>
            <p className="mt-3 text-left download-content" style={{paddingTop:"6px",}}>
              Stress-free moving and storage solutions in the palm of your hand
            </p>
            <div className="row mt-3">
              <a href="#" className="col-md-6  app-download-button">
                <img src="img/GooglePlay.png" alt="App" width="100%" height="100%" />
              </a>
              <a
                href="https://apps.apple.com/us/app/bluebox-rent/id6450204692"
                className="col-md-6  app-download-button">
                <img src="img/AppStore.png" alt="App" width="100%" height="100%" />
              </a>
            </div>
          </div>
        </div>
        <div className="row section-xs " style={{ marginTop: '10px', paddingBottom: '30px' }}>
          <p className="about-us-heading fw-600 d-center">
            Download our app
            <div className="land-divider"></div>
          </p>
          <p className="mt-3 text-center" style={{paddingTop:"22px"}}>
            Stress-free moving and storage solutions in the palm of your hand
          </p>

          <div className="col-12  d-flex justify-content-end about-image">
            <Suspense fallback={<div>Loading...</div>}>
              <LazyImage className="app-section-img-lg" src="img/App-section.png" alt="" />
            </Suspense>
            <Suspense fallback={<div>Loading...</div>}>
              <LazyImage className="app-section-img-sm" src="img/App-section-sm.png" alt="" />
            </Suspense>
          </div>
          <div className="col-12  d-flex flex-column fs-23 about-text">
            <div className="row mt-3 justify-content-center w-100">
              <a href="" className="col-md-6 col-sm-12 app-download-button">
                <img src="img/GooglePlay.png" alt="" />
              </a>
              <a
                href="https://apps.apple.com/us/app/bluebox-rent/id6450204692"
                className="col-md-6 col-sm-12 app-download-button app-store-btn">
                <img src="img/AppStore.png" alt="" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- beats cardboard box --> */}
      {/* <section className="cardboardBox">
        <div className="container-fluid">
          <div className="cardbox">
            <div className="row">
              <div className="col-md-12">
                <img src="img/new-boxes-desktop1.png" alt="" />
              </div>
              <div id="mydiv">
                <img src="img/new-boxes-mobile1.png" className="image_mobile" alt="" />
                <img src="img/new-boxes-mobile2.png" className="image_mobile" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* <!-- beats cardboard box --> */}

      {/* <!-- slider Section --> */}
      <section className="sliderSection py-3 position-relative">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="sliderSection-heading">
                <h5 className="sliderSection-title">{`Don't take it from us...`}</h5>
                <h2 className="sliderSection-subTitle">
                  {`Here’s what our`}
                  <br /> customers are
                  <br /> saying
                </h2>
              </div>
            </div>
            <div className="col-md-8">
              <div className="slider">
                <SimpleSlider testimonials={testimonials} />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- zip code Section --> */}

      <Container fluid={true} className="px-5 how-we-works-land" style={{ paddingTop: '3rem' }}>
        <Row className="align-items-center justify-content-center pt-4">
          <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12}>
            <p className="hww-head">Moving or need more storage?</p>
            <Form
              form={form}
              layout="vertical"
              onFinish={handleZipCode}
              onFinishFailed={onFinishFailed}
              autoComplete="off">
              <Row>
                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} className="pb-0">
                  <Form.Item
                    name="service_type"
                    label="Service"
                    rules={[
                      {
                        required: true
                      }
                    ]}>
                    <Select placeholder="Select an option" size="large">
                      <Option value="moving_box">Rent Moving Boxes</Option>
                      <Option value="STORAGE_ON_DEMAND">Storage On-Demand</Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Form.Item
                    noStyle
                    shouldUpdate={(prevValues, currentValues) =>
                      prevValues.service_type !== currentValues.service_type
                    }>
                    {({ getFieldValue }) =>
                      getFieldValue('service_type') === 'STORAGE_ON_DEMAND' ? (
                        <Form.Item
                          name="delivery_zipcode"
                          label="Zip Code where you’d like storage boxes delivered"
                          rules={[
                            {
                              required: true
                            }
                          ]}>
                          <Input size="large" className="hiw-input" placeholder="Enter Zip code" />
                        </Form.Item>
                      ) : (
                        <Form.Item
                          name="pickup_zipcode"
                          label="Zip code of your current address?"
                          rules={[
                            {
                              required: true
                            }
                          ]}>
                          <Input size="large" className="hiw-input" placeholder="Enter Zip code" />
                        </Form.Item>
                      )
                    }
                  </Form.Item>

                  <Form.Item
                    noStyle
                    shouldUpdate={(prevValues, currentValues) =>
                      prevValues.service_type !== currentValues.service_type
                    }>
                    {({ getFieldValue }) =>
                      getFieldValue('service_type') === 'moving_box' ? (
                        <Form.Item
                          name="delivery_zipcode"
                          label="Zip code of your new address?"
                          rules={[
                            {
                              required: true
                            }
                          ]}>
                          <Input size="large" className="hiw-input" placeholder="Enter Zipcode" />
                        </Form.Item>
                      ) : null
                    }
                  </Form.Item>

                  <Form.Item>
                    <Button
                      loading={submitLoader}
                      size="large"
                      type="primary"
                      htmlType="submit"
                      className="land-card-btn"
                      block>
                      Start Your Order
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Container>

      {/* <RenderIf isTrue={props.storeStatus === "open"}>
        <section
          className="hero move-location position-relative location custom "
          style={{
            background: '#FAF9F6'
          }}>
          <div className="container">
            <div id="locations-content" className="ng-scope">
              <div
                className="row align-content-center"
                style={{
                  jstifyContent: 'center'
                }}>
                <div className="columns small-12 large-10 large-offset-1 end" style={{ marginLeft: "15%", marginRight: "15%" }}>
                  <div className="order-box locationform"> */}
      {/* <h2><img width="32" src="img/icon-truck.png" data-interchange="[/assets/img/icon-truck@2x.png, (retina)]" /> Check If We Service Your Area</h2> */}

      {/* <div className="">
                      <div className="">
                        <div className="modal-header">
                          <img src="img/logo.png" className="img-fluid" alt="" />
                          <h5>Where are you moving?</h5> */}
      {/* <button type="button" className="close" onClick={props.hideModal}>
                                                              <span aria-hidden="true">&times;</span>
                                                          </button> */}
      {/* </div>
                        <div className="modal-body">
                          <div className="row">
                            {isError ? <p style={{ color: 'red' }}>{errorMsg} </p> : ''}
                            <div className="col-md-6 p-2">
                              Zip code of your current address?
                              <input
                                type="text"
                                id="ship-address"
                                className="form-control"
                                placeholder="Enter Zip code"
                                name="pickup_zipcode"
                                value={values.pickup_zipcode}
                                onChange={(e) => handleChange(e)}
                              />
                            </div>
                            <div className="col-md-6 p-2">
                              Zip code of your new address?
                              <input
                                type="text"
                                id="pickup-address"
                                className="form-control"
                                placeholder="Enter Zip code"
                                name="delivery_zipcode"
                                value={values.delivery_zipcode}
                                onChange={(e) => handleChange(e)}
                              />
                            </div>
                            <div className="col-12 text-right">
                              <a
                                href="box-package.html"
                                className="mt-4 btn continue-zip-code-btn"
                                onClick={(e) => handleZipCode(e)}>
                                Continue
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
      {/* </Modal> */}
      {/* </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </RenderIf> */}

      <br />
      {/* <!-- we deliver to this area --> */}
    </>
  );
}
Home.propTypes = {
  setShowHideHeader: PropTypes.any,
  setshowHideFooter: PropTypes.any,
  setshowHideinnerFooter: PropTypes.any,
  zipCodeSection: PropTypes.any,
  scrollToSection: PropTypes.any,
  setshowZipModal: PropTypes.any,
  storeStatus: PropTypes.any,
  storeStatusMessage: PropTypes.any
};
